import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import { object, func, objectOf } from 'prop-types';
import { startSetHoldDetails, startSetHoldDetailsSettings } from '../../../../actions/finances';
import { startSetSlaveHoldDetails, startSetSlaveHoldDetailsSettings } from '../../../../actions/slaves';
import Card from '../../../../components/Card/Card';
import Pagination from '../../../../components/Pagination/Pagination';
import PaymentHoldDetailsList from '../../../../components/Finances/PaymentHoldDetailsList';
import PaymentsCurrencyControl from '../../../../components/Finances/PaymentsCurrencyControl';
import { getSlaveId, isMaster } from '../../../../components/Statistics/statisticsHelpers';
import { currencyToSign } from '../../../../utils/utils';
import { iFMessage } from '../../../../hoc/IntlComponents';
import { LocalStorage } from '../../../../utils/utils';
import TableSettings from '../Offer/TableSettings';
import Icon from '../../../../components/Icon/Icon';

class PaymentHoldDetails extends Component {
    static propTypes = {
        details: objectOf(object.isRequired),
        settings: objectOf(object.isRequired),
        startSetHoldDetails: func.isRequired,
        startSetHoldDetailsSettings: func.isRequired,
    };

    static defaultProps = {
        details: {},
        settings: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            limit: 20,
            page: 0,
            currency: 0,
            settingsModalOpen: false,
            tableSettings: {}
        };

        this.$el = React.createRef();
    }

    componentDidMount() {
        const {
            setLoadingState
        } = this.props;
        this.getDetails().then(() => {
            const { active } = this.filterCurrenciesControl();
            this.getSettings().then(() => {
                setLoadingState(false);
                this.setState(() => ({ currency: active }));
            });
        });
        const tableSettings = LocalStorage.get('paymentHoldTableSettings') ? LocalStorage.get('paymentHoldTableSettings') : {
            created: true,
            accepted: true,
            flow: true,
            offer: true,
            transfer: true,
            amount: true,
        };
        this.setState({ tableSettings });
    }

    getSettings = () => {
        const {
            currencies,
            startSetHoldDetailsSettings,
            startSetSlaveHoldDetailsSettings,
        } = this.props;
        return !isMaster() ?
            startSetHoldDetailsSettings(currencies)
            :
            startSetSlaveHoldDetailsSettings(currencies, getSlaveId());
    }

    getDetails = () => {
        const { limit, page } = this.state;
        const {
            currencies,
            setLoadingState,
            startSetHoldDetails,
            startSetSlaveHoldDetails,
        } = this.props;
        setLoadingState(true);
        return !isMaster() ?
            startSetHoldDetails({ limit, page }, currencies)
            :
            startSetSlaveHoldDetails({ limit, page, id: getSlaveId() }, currencies);
    };

    makeDetails = (details = [], settings = {}) => {
        const { flows = {}, offers = {} } = settings;

        return details.map(detail => {
            const formatted = {};

            if (Object.keys(flows).length > 0) {
                formatted.flow = flows[detail.stream_id];
            }

            if (Object.keys(offers).length > 0) {
                formatted.offer = offers[detail.offer_id];
            }

            return { ...detail, ...formatted };
        });
    };

    changePage = page => {
        const {
            setLoadingState
        } = this.props;
        setLoadingState(true);
        this.setState(
            () => ({ page }),
            () => {
                this.getDetails().then(() => this.getSettings()).finally(() => {
                    setLoadingState(false);
                });
            },
        );
    };

    changeCurrency = index => {
        this.setState(() => ({
            currency: index,
        }));
    };

    // renderHoldDisclamer = details => {
    //   const { intl } = this.props;
    //   const minCurrencies = {
    //     rub: 800,
    //     usd: 20,
    //   };

    //   const nextPayments = {};
    //   let disclamerMessage = null;
    //   let ruPayment = `(${iFMessage({ intl, id: 'payments.hold.min-amount.less' })} ${minCurrencies['rub']} ₽)`;
    //   let usdPayment = `(${iFMessage({ intl, id: 'payments.hold.min-amount.less' })} ${minCurrencies['usd']} $)`;

    //   let date = null;

    //   Object.keys(details).forEach(detailKey => {
    //     const { amount, items } = details[detailKey];
    //     if (amount >= minCurrencies[detailKey]) {
    //       nextPayments[detailKey] = {
    //         value: `${amount} ${currencyToSign(detailKey)}`,
    //         date: items[0].hold_expire,
    //       };
    //     }
    //   });

    //   Object.keys(nextPayments).forEach((nextPaymentKey, index) => {
    //     const nextDate = nextPayments[nextPaymentKey].date;
    //     if (index === 0) {
    //       date = nextDate;
    //     } else {
    //       if (nextPayments[nextPaymentKey] <= date) {
    //         date = nextDate;
    //       }
    //     }
    //   });

    //   if (Object.keys(nextPayments).length) {
    //     if (nextPayments['rub']) {
    //       ruPayment = `${nextPayments['rub'].value}`;
    //     }
    //     if (nextPayments['usd']) {
    //       usdPayment = `${nextPayments['usd'].value}`;
    //     }
    //     disclamerMessage = (
    //       <Fragment>
    //         <FormattedMessage
    //           id="payments.hold.min-amount.calculated"
    //           defaultMessage="The nearest scheduled payment {date}: RUS {ruPayment}, USD {usdPayment}"
    //           values={{
    //             date: moment.unix(date).format('DD.MM'),
    //             ruPayment,
    //             usdPayment,
    //           }}
    //         />
    //       </Fragment>
    //     );
    //   } else {
    //     disclamerMessage = (
    //       <FormattedMessage
    //         id="payments.hold.min-amount"
    //         defaultMessage="The nearest scheduled payment will be calculated upon reaching the minimum amount of {amount} or {ruAmmount} rubles"
    //         values={{ amount: `${minCurrencies['usd']} USD`, ruAmmount: `${minCurrencies['rub']}` }}
    //       />
    //     );
    //   }
    //   return (
    //     <p className="hold-disclaimer">
    //       {disclamerMessage}
    //     </p>
    //   );
    // }

    renderHoldDisclamer = (details) => {
        const currency = this.state.currency === 0 ? 'rub' : 'usd';
        const { amount, date } = details[currency];
        const disclaimer = amount && date ? (
            <Fragment>
                <FormattedMessage
                    id="payments.hold.total"
                    defaultMessage="The nearest scheduled payment {date}: {currency} {amount}{sign}"
                    values={{
                        date,
                        amount,
                        sign: currencyToSign(currency),
                        currency: currency.toUpperCase()
                    }}
                />
            </Fragment>
        ) : (
            <Fragment>
                <FormattedMessage
                    id="payments.hold.min-amount"
                    defaultMessage="The nearest scheduled payment will be calculated upon reaching the minimum amount of {amount} or {ruAmmount} rubles"
                    values={{
                        date,
                        amount: '20$',
                        ruAmmount: `800`,
                        currency: currency.toUpperCase()
                    }}
                />
            </Fragment>
        )
        return (
            <p className="hold-disclaimer">
                {disclaimer}
            </p>
        )
    }

    renderHoldDetailsList = () => {
        const { details, settings, loading, currencies } = this.props;
        const { currency: active, tableSettings } = this.state;
        if (this.props.theme === 3) {
            if (
                !loading &&
                currencies[active] &&
                details[currencies[active].toLowerCase()] &&
                details[currencies[active].toLowerCase()].items &&
                details[currencies[active].toLowerCase()].items.length
            ) {
                const currency = currencies[active].toLowerCase();
                return (
                    <Fragment>
                        <PaymentHoldDetailsList
                            tableSettings={tableSettings}
                            details={this.makeDetails(details[currency].items, settings[currency])}
                            amount={details[currency].amount}
                        />
                        {this.renderHoldDisclamer(details)}
                    </Fragment>
                );
            } else {
                return (
                    <Fragment>
                        <PaymentHoldDetailsList
                            tableSettings={tableSettings}
                            emptyTable={true}
                        />
                    </Fragment>
                );
            }
        } else {
            if (
                !loading &&
                currencies[active] &&
                details[currencies[active].toLowerCase()] &&
                details[currencies[active].toLowerCase()].items &&
                details[currencies[active].toLowerCase()].items.length
            ) {
                const currency = currencies[active].toLowerCase();
                return (
                    <Fragment>
                        <PaymentHoldDetailsList
                            details={this.makeDetails(details[currency].items, settings[currency])}
                            amount={details[currency].amount}
                        />
                        {this.renderHoldDisclamer(details)}
                    </Fragment>
                );
            } else {
                return (
                    <div className="card-empty">
                        <FormattedMessage id="payments.hold.empty" defaultMessage="No Details" />
                    </div>
                );
            }
        }
    };

    filterCurrenciesControl = () => {
        const { details, currencies } = this.props;
        const { currency } = this.state;
        let active = currency;
        if (!Object.keys(details).length) {
            return {};
        }
        if (
            details &&
            details[currencies[active].toLowerCase()] &&
            !details[currencies[active].toLowerCase()].count
        ) {
            const firstNotEmptyCurrency = Object.keys(details).find(
                currency => details[currency].count > 0,
            );
            if (firstNotEmptyCurrency) {
                active = currencies.indexOf(firstNotEmptyCurrency.toUpperCase());
            }
        }

        return { active };
    };

    toggleModal = () => this.setState({ settingsModalOpen: !this.state.settingsModalOpen })

    editSettings = settings => {
        const { settingsModalOpen, tableSettings } = this.state;
        LocalStorage.set('paymentHoldTableSettings', { ...tableSettings, ...settings })
        this.setState({ tableSettings: { ...tableSettings, ...settings }, settingsModalOpen: !settingsModalOpen })
    }

    render() {
        const { page, limit, currency: active, settingsModalOpen, tableSettings } = this.state;
        const { details, currencies } = this.props;
        const pageCount =
            currencies[active] && details && details[currencies[active].toLowerCase()]
                ? Math.ceil(details[currencies[active].toLowerCase()].count / limit)
                : 0;

        const tabs = [<PaymentsCurrencyControl
            active={active}
            currencies={currencies}
            onCurrencyChange={this.changeCurrency}
        />, <Button color="primary" size="sm" onClick={this.toggleModal} >
            <Icon type='kma-panel' tag='i' />
        </Button>]

        return (
            <div className="payments-hold-details" ref={this.$el}>
                <Card.WithControls className='no-padding' title="payments.hold.title" defaultMessage="Hold detail" controls={tabs}>
                    <Card.Body className="no-padding">
                        {this.renderHoldDetailsList()}
                    </Card.Body>

                    {pageCount > 1 && (
                        <Card.Footer>
                            <Pagination
                                pageCount={pageCount}
                                onPageChange={this.changePage}
                                activePage={page + 1}
                                scrollToAfterPageChanged={{ ref: this.$el.current }}
                            />
                        </Card.Footer>
                    )}


                    <Modal
                        isOpen={settingsModalOpen}
                        toggle={this.toggleModal}
                    >
                        <ModalHeader toggle={this.toggleModal}>
                            <FormattedMessage id="postback.logs.settings" defaultMessage='Customize fields' />
                        </ModalHeader>
                        <ModalBody>
                            <TableSettings settings={tableSettings} editSettings={this.editSettings} />
                        </ModalBody>
                    </Modal>
                </Card.WithControls>
            </div>
        );
    }
}

const mapStateToProps = ({ finances, app, slaves }) => {
    const master = isMaster();
    return {
        details: !master ? finances.details : slaves.details,
        settings: !master ? finances.settings : slaves.settings,
        currencies: app.globalSettings.currencies,
    };
};

const mapDispatchToProps = dispatch => ({
    startSetHoldDetails: (params, currencies) => dispatch(startSetHoldDetails(params, currencies)),
    startSetHoldDetailsSettings: currencies => dispatch(startSetHoldDetailsSettings(currencies)),

    startSetSlaveHoldDetails: (params, currencies) => dispatch(startSetSlaveHoldDetails(params, currencies)),
    startSetSlaveHoldDetailsSettings: (currencies, id) => dispatch(startSetSlaveHoldDetailsSettings(currencies, id)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentHoldDetails);
